const loyaltyOptedIn = (preferences: Record<string, any>): boolean =>
  preferences.loyaltyOptIn === undefined ? true : preferences.loyaltyOptIn;
export default loyaltyOptedIn;
